import { DateTime, Interval } from 'luxon';

import {
  DATASET_SHARING_STATES,
  type DatasetShareProps,
} from 'companion-app-components/flux/dataset-shares/datasetSharesTypes';

import { APP_STRING_NOT_APPLICABLE } from 'utils/constants';

export const getOwnerName = (grantorFirstName?: string, grantorLastName?: string) => {
  if (!grantorFirstName && !grantorLastName) {
    return APP_STRING_NOT_APPLICABLE;
  }
  const firstName = grantorFirstName || '';
  const lastName = grantorLastName || '';

  return `${firstName} ${lastName}`;
};

export const formatLastSyncedDate = (date: string) => {
  const originalDateTime = DateTime.fromISO(date);
  return originalDateTime.toFormat('MM/dd/yy, HH:mm');
};

export const checkIfInviteExpired = (date?: string) => {
  if (!date) { return false; }
  
  const dtNow = DateTime.local();
  const dtLastSent = DateTime.fromISO(date);
  const diff = Interval.fromDateTimes(dtLastSent, dtNow);
  const diffHours = diff.length('hours');
  if (diffHours > 24) {
    return true;
  }
  return false;
};

export const checkIfWebfirstDataset = (platform?: string) => 
  platform ? ['QWIN_MWF', 'QMAC_MWF'].includes(platform) : false;

export const getSharingInviteDisplay = (sharing?: Partial<DatasetShareProps>) => {
  const hasExpiredInvite = checkIfInviteExpired(sharing?.lastInviteSent);

  if (sharing?.state === DATASET_SHARING_STATES.INVITED && hasExpiredInvite) {
    return {
      isInvited: true,
      invitedLabel: 'Invitation Expired - ',
      color: 'number.negative',
    };
  }

  if (sharing?.state === DATASET_SHARING_STATES.INVITED) {
    return {
      isInvited: true,
      invitedLabel: 'Invited - ',
      color: 'inherit',
    };
  }

  if (sharing?.state === DATASET_SHARING_STATES.ABANDONED) {
    return {
      isInvited: true,
      invitedLabel: 'No longer shared - ',
      color: 'inherit',
    };
  }

  return {
    isInvited: false,
    invitedLabel: '',
    color: 'inherit',
  };
};

export const getSharedUserFullName = (granteeFirstName?: string, granteeLastName?: string) =>
  `${granteeFirstName || ''} ${granteeLastName || ''}`.trim();

export const shouldDisableShareOptions = (
  sharingCount: number,
  maximumSharesPerDataset: number,
  isCFODataset: boolean,
  isCurrentDataset: boolean,
) => (
  sharingCount >= maximumSharesPerDataset
  || (isCFODataset && !isCurrentDataset)
);
